export default __webpack_public_path__ + "static/large-desktop-home-map-static-img-6cd09127db722fd6c9b892f0674ed3d4.jpg";